export class MapsPlanRoute {

  constructor() {
    this.googleMap = document.querySelector('.google-maps')

    if (this.googleMap) {
      this.planRouteLink = document.querySelector('.google-maps-plan-route')

      this.applyUrl()
    }
  }

  applyUrl() {
    const baseUrl = this.planRouteLink.dataset.mapsUrl
    const latValue = this.googleMap.dataset.mapsLat
    const longValue = this.googleMap.dataset.mapsLong

    // apply the full URL
    this.planRouteLink.href = `${baseUrl}${latValue},${longValue}`
  }
}